import "./SurveyTakingPage.scss";

import { Flex, Text } from "@fluentui/react-northstar";
import React, { useState } from "react";
import { useParams } from "react-router";

import ConfirmationImage from "../../_shared/assets/confirmation-image-ok-mark.svg";
import { SurveyTakingForm } from "../../survey/pages/Meetings/components/SurveyTakingForm";
import { MSALPageHost } from "../MSALPageHost";
import { useMicrosoftAuth } from "../useMicrosoftAuth";

const SurveyTakingPageComponent: React.FC = () => {
  const { surveyId } = useParams<{ surveyId: string }>();
  const [isCompleted, setIsCompleted] = useState<boolean>();

  const { result } = useMicrosoftAuth(["openid", "profile"]);

  if (!result?.idToken) {
    return null;
  }

  return (
    <Flex column>
      <Flex hAlign="center" vAlign="center" className="survey-taking-page__content">
        {!isCompleted && (
          <div className="survey-taking-page__form">
            <SurveyTakingForm
              contextOrApiToken={result.idToken}
              surveyId={surveyId}
              trackingSource="web"
              hideHelp
              onCompleted={() => setIsCompleted(true)}
            />
          </div>
        )}
        {isCompleted && (
          <Flex column gap="gap.small">
            <Text
              content="You have completed this polly!"
              size="large"
              weight="bold"
              align="center"
            />
            <img src={ConfirmationImage} height={100} alt="confirmed" />
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export const SurveyTakingPage: React.FC = () => {
  return (
    <MSALPageHost
      title={
        <Text weight="bold" align="center">
          Sign in to view the survey
        </Text>
      }
    >
      <SurveyTakingPageComponent />
    </MSALPageHost>
  );
};
